export default "__VITE_ASSET__DSdWOVVs__"